import { createBrowserHistory, History, LocationState } from 'history';

let history: History<LocationState>;

export const configureHistoryService = (basename: string): void => {
    history = createBrowserHistory({ basename });
};

const historyService = {
    replace(newUrl: string): void {
        history.replace(newUrl);
    },

    push(newUrl: string, state: { silent: boolean }): void {
        history.push(newUrl, state);
    },

    getHistory(): History<LocationState> {
        return history;
    },
};
export default historyService;
